<template>
  <div class="maincont child" id="troubleshooting-history">
    <div class="ef--inner2 filter">
      <div class="page-title">
        <h2>トラブル対応履歴</h2>
        <a class="function-btn"
          @click="showDialogCreate()">
          新規登録
        </a>
      </div>
      <div id="page_info" class="page-info page-info-frame">
        <div class="list-info">
          <table class="list-table">
            <thead>
              <tr>
                <th rowspan="1" style="width: 30%">トラブル内容</th>
                <th rowspan="1" style="width: 20%">原因</th>
                <th rowspan="1" style="width: 20%">対応内容</th>
                <th rowspan="1" style="width: 10%">対応者</th>
                <th rowspan="1" style="width: 10%">対応開始日</th>
                <th colspan="1" style="width: 10%">対応完了日</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in dataTroubleInfo"
                v-bind:key="index" tabindex="0"
                @click="showDialogUpdate(item.trouble_id)">
                <td>{{item.trouble_content}}</td>
                <td>{{item.trouble_cause}}</td>
                <td>{{item.process_content}}</td>
                <td class="text-center">{{item.name}}</td>
                <td class="text-center">{{item.start_date}}</td>
                <td class="text-center">{{item.end_date}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <TroubleshootingHistoryDialog
      v-if="showDialog"
      :action="action"
      :troubleId="troubleId"
      @onCreate="onCreate"
      @onUpdate="onUpdate"
      @close="onclose"
    ></TroubleshootingHistoryDialog>
  </div>
</template>

<script>
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import TroubleshootingHistoryDialog from "../../components/TroubleshootingHistoryDialog.vue"

export default {
  name: "troubleshooting-history",
  components: {
    TroubleshootingHistoryDialog
  },
  data: function() {
    return {
      action: '',
      showDialog: false,
      troubleId: null,
      dataTroubleInfo: [],
      formatDate: "YYYY-MM-DD",
      timeDefaultUTC: "T00:00:00Z",
      actions: ['create', 'update'],
    };
  },
  updated: function() {
  },
  methods: {
    getListTroubleInfo: function() {
      this.$axios.get("/srv/api/trouble_info/list", {
        withCredentials: true
      }).then(response => {
        if (typeof response.data == "object") {
          this.dataTroubleInfo = response.data.trouble_info_list;
        } else {
          alert("session time out");
          this.$store.dispatch("logout");
          this.$router.push("/login");
        }
      }).catch(error => {
        console.log(error);
      });
    },
    showDialogCreate: function () {
      this.troubleId = null;
      this.action = this.actions[0];
      this.showDialog = true;
    },
    showDialogUpdate: function (troubleId) {
      this.troubleId = troubleId;
      this.action = this.actions[1];
      this.showDialog = true;
    },
    onclose: function () {
      this.showDialog = false;
    },
    onCreate: function (payload) {
      payload.start_date = payload.start_date + this.timeDefaultUTC;
      payload.end_date = payload.end_date + this.timeDefaultUTC;
      this.$axios.post(`/srv/api/trouble_info`, payload, {
          withCredentials: true
      }).then(response => {
        const data = response.data;
        if (data.status !== undefined) {
          if (data.status === "success") {
            this.getListTroubleInfo();
            alert("登録が完了しました。");
            this.onclose();
          } else {
            alert("登録できませんでした");
          }
        } else {
          alert("登録できませんでした");
        }
      })
      .catch(error => {
        console.log(error);
      });
    },
    onUpdate: function (payload) {
      payload.start_date = payload.start_date + this.timeDefaultUTC;
      payload.end_date = payload.end_date + this.timeDefaultUTC;
      this.$axios.put(`/srv/api/trouble_info`, payload, {
          withCredentials: true
      }).then(response => {
        const data = response.data;
        if (data.status !== undefined) {
          if (data.status === "success") {
            this.getListTroubleInfo();
            alert("更新が完了しました。");
            this.onclose();
          } else {
            alert("更新できませんでした。");
          }
        } else {
          alert("更新できませんでした。");
        }
      })
      .catch(error => {
        console.log(error);
      });
    },
  },
  mounted: function() {
    this.getListTroubleInfo();
  }
};
</script>